import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import { bootBranding } from './app/branding'
import { bootLocale } from './lib/i18n'
import { bootTheme } from './lib/theme'
import './styles/global.css'

/* Before the first render: the identity is two CSS variables on :root, and
   applying them after paint would flash the platform default first. The same
   goes for `lang`/`dir` — index.html ships the Arabic pair, and correcting it
   after paint would flip the whole layout in front of the user — and for the
   theme, where the flash would be a white page, which is the one thing a dark
   theme exists to prevent.

   Theme before branding: branding derives the rail from the active theme. */
bootLocale()
bootTheme()
bootBranding()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
